import React, {ReactElement} from 'react';

import {useEffect} from 'react';
import {pageName} from '../../../lib/constants';
import {setPageName} from '../../../lib/tagmanager';
import {setAppBarTitle, setBackNavEnabled} from '../../../redux/globalSlice';
import {useAppDispatch} from '../../../redux/hooks';
import {ProductAdded} from './ProductAdded';

const LMRscanProduct = (): ReactElement => {
  useEffect(() => {
    setPageName(pageName.promotionPage);
  }, []);
  useEffect(() => {
    dispatch(setAppBarTitle('Item added to bag'));
    dispatch(setBackNavEnabled(true));
    return () => {
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
    };
  }, [setAppBarTitle]);
  const dispatch = useAppDispatch();
  return (
    <div>
      <ProductAdded />
    </div>
  );
};

export default LMRscanProduct;
